// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footer_bottom":"Footer_footer_bottom__RuzVv","links":"Footer_links__wMgLO","header":"Footer_header__dnSM4","logo":"Footer_logo__+JiYo"};